import React from "react";
import PropTypes from "prop-types";
import Icon from "components/Icon";
import classNames from "classnames";
import {playgroundTypes} from "domain/Directories/types";
import StationRow from "components/StationRow";

const PlaygroundDetailsFields = ({playground, type}) => {
    const fields = [
        {
            name: `Адрес`,
            value: `${playground.address}`,
            icon: `location`,
        },
        {
            name: `Метро`,
            value: playground?.stations || [],
            icon: `underground`,
            isArray: true,
            component: playground?.stations && playground?.stations.map((elem, key) => <StationRow
                color={elem.metro_line.color}
                title={elem.name}
                id={elem.id}
                key={key}/>)
        },
        {
            name: `Номер телефона`,
            value: playground?.phone ? (
                <a href={`tel:${playground?.phone}`}>{playground.phone}</a>
            ) : null,
            icon: `call`,
        },
        {
            name: `Тип`,
            value: type?.name,
            icon: `info`,
        },
    ].filter((item) => !!item.value && item.value !== "");

    if (fields.length === 0) {
        return null;
    }

    return (
        <ul className="profile__list profile__list_wrapped">
            {fields.map(({name, value, icon, classes, isArray, component}) => (
                isArray && value.length < 1 ? null : <li key={name} className={isArray && 'station station_detail'}>
                    <span className="icon-container">
                        <Icon type={icon}/>
                    </span>

                    <p className="profile__param">{name}</p>
                    {isArray ?
                        <p className={classNames("profile__value", classes)}>
                            {component}
                        </p>
                        : <p className={classNames("profile__value", classes)}>
                            {value}
                        </p>}

                </li>
            ))}
        </ul>
    );
};

PlaygroundDetailsFields.propTypes = {
    playground: playgroundTypes,
    cityName: PropTypes.string,
    type: PropTypes.object,
};

export default PlaygroundDetailsFields;
